export const WorkStationCategoryEnum =[
    {name : 'DEHEADING',value:1},{name : 'GRADING',value:2},{name:'VALUE ADDITION',value:3},{name:'COOKING',value:4},{name:'SOAKING',value:5},{name:'FREEZING',value:6},{name:'GRN',value:7}
]